module.exports = __webpack_public_path__ + "img/game_main_pc_13_off.e4cd2995.png";